import Reveal from "@/components/Reveal";
import { WhatsAppIcon, WeChatIcon } from "@/components/Logo";
import { WHATSAPP_LINK, WECHAT_LINK, WECHAT_ID } from "@/site";
import { useLang } from "@/i18n";

const ChatCards = () => {
  const { t } = useLang();
  const channels = [
    {
      name: "WhatsApp",
      handle: t.chat.whatsappHandle,
      sub: WHATSAPP_LINK.replace("https://wa.me/", "+").split("?")[0],
      img: "/images/qr-whatsapp.png",
      link: WHATSAPP_LINK,
      testid: "whatsapp",
      Icon: WhatsAppIcon,
      tile: "from-[#25D366] to-[#128C7E]",
    },
    {
      name: "WeChat",
      handle: t.chat.wechatHandle,
      sub: `ID: ${WECHAT_ID}`,
      img: "/images/qr-wechat.png",
      link: WECHAT_LINK,
      testid: "wechat",
      Icon: WeChatIcon,
      tile: "from-[#07C160] to-[#059048]",
    },
  ];

  return (
    <section id="chat" data-testid="chat-section" className="border-t border-ink/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-clay">{t.chat.overline}</p>
          <h2 data-testid="chat-heading" className="mt-6 font-serif text-4xl tracking-tight text-ink sm:text-5xl">
            {t.chat.h2a} <em className="italic text-clay">{t.chat.h2b}</em>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ink/60">{t.chat.sub}</p>
        </Reveal>

        <div className="mx-auto mt-16 grid max-w-3xl grid-cols-1 gap-6 sm:grid-cols-2">
          {channels.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.12}>
              <div
                data-testid={`chat-card-${c.testid}`}
                className="group flex h-full flex-col items-center rounded-3xl border border-ink/10 bg-white p-10 text-center shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(0,0,0,0.10)]"
              >
                <div className={`flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br ${c.tile} text-white shadow-lg transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-3`}>
                  <c.Icon className="h-8 w-8" />
                </div>
                <p className="mt-5 font-serif text-2xl tracking-tight text-ink">{c.name}</p>
                <p className="mt-1 text-sm font-medium text-ink/70" data-testid={`chat-handle-${c.testid}`}>{c.handle}</p>
                <p className="mt-0.5 text-xs uppercase tracking-[0.18em] text-ink/40">{c.sub}</p>

                <div className="mt-6 overflow-hidden rounded-2xl border border-ink/10 bg-white p-3">
                  <img
                    src={c.img}
                    alt={`${c.name} QR code for ${c.handle}`}
                    data-testid={`chat-qr-${c.testid}`}
                    loading="lazy"
                    className="h-40 w-40 object-contain transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <a
                  href={c.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`chat-open-${c.testid}`}
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-bone transition-colors duration-300 hover:bg-clay"
                >
                  <c.Icon className="h-4 w-4" />
                  {t.chat.open}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChatCards;
